import React from 'react';

export default function AdminHeader({ user, onSignOut, navigate }) {
  return (
    <header className="admin-top-header">
      <div className="admin-header-brand">
        <span className="admin-brand-logo">EX</span>
        <div>
          <strong className="admin-brand-title">Mr Excel Sri Lanka</strong>
          <span className="admin-brand-subtitle">Admin Console</span>
        </div>
      </div>
      
      <div className="admin-header-actions">
        <button 
          className="admin-action-btn back-site" 
          onClick={() => navigate('')}
        >
          🌐 Back to Site
        </button>
        <div className="admin-user-profile">
          <div className="admin-user-avatar">
            {user?.email?.[0].toUpperCase() || 'A'}
          </div>
          <div className="admin-user-details">
            <span className="admin-user-name">Administrator</span>
            <span className="admin-user-email">{user?.email}</span>
          </div>
        </div>
        <button 
          className="admin-action-btn logout-btn" 
          onClick={onSignOut}
        >
          Sign Out
        </button>
      </div>
    </header>
  );
}
